export default __webpack_public_path__ + "static/media/materne_bg.453275a5.png";